import React from "react";

import BackArrowButton from "../parts/back-arrow-button";
import UnitInput from "../parts/inputs/unit-input";
import LoginWrapper from "./LoginWrapper";
import OnboardingRadio from "../parts/inputs/onboarding-radio";

function showRMField(hideRMs, collectRepMax, field) {
  if (collectRepMax?.length > 0) {
    return collectRepMax.includes(field);
  }
  return !hideRMs && ["squat", "bench", "deadlift"].includes(field);
}

const SignupDetailsView = (props) => {
  React.useEffect(() => {
    document.querySelector('input[name="repMaxSquat"]')?.focus();
  }, []);

  const handleUnitsChange = (to) => {
    props.locals.units = to;
    props.handleFieldChange({ target: { name: "units", value: to } });
  };

  const {
    onBack,
    handleUserDetails,
    handleFieldChange,
    units,
    repMaxSquat,
    repMaxBench,
    repMaxDeadlift,
    repMaxClean,
    repMaxJerk,
    repMaxSnatch,
    repMaxOverheadPress,
  } = props;

  let coachSettings = sessionStorage.getItem("coachSettings");
  if (coachSettings) {
    coachSettings = JSON.parse(coachSettings);
  }
  const hideRMs = !!coachSettings?.hideRepMaximums;
  const collectRepMax = coachSettings?.collectRepMax;
  const showRMText = !hideRMs || collectRepMax?.length > 0;

  return (
    <LoginWrapper
      mainClass="Onboarding athlete profile-details full-w"
      left={
        <form method="POST" data-noreset>
          <section className="mobile-hidden">
            <BackArrowButton onBack={(_) => onBack(4)} />
            <h1>Profile details</h1>
            {showRMText && (
              <p>
                Enter your 1RMs to help us calculate the weights for you to use
                in your programs. These can always be changed later, so include
                your best estimate of a weight you can lift for 1 repetition on
                any day.
              </p>
            )}
          </section>
          <header className="only-show-mobile">
            <div>
              <BackArrowButton onBack={(_) => onBack(4)} />
              <div>
                <h1>Profile details</h1>
              </div>
            </div>
            {showRMText && (
              <p>
                Enter your 1RMs to help us calculate the weights for you to use
                in your programs. These can always be changed later, so include
                your best estimate of a weight you can lift for 1 repetition on
                any day.
              </p>
            )}
          </header>

          <section>
            <div className="measurement-system">
              <label htmlFor="units">Measurement system</label>
              <OnboardingRadio
                label={null}
                name="units"
                onClick={handleUnitsChange}
                options={[
                  {
                    value: "metric",
                    label: "Kilogram",
                    defaultChecked: true,
                  },
                  { value: "imperial", label: "Pound" },
                ]}
                value={units}
              />
            </div>

            {showRMText && (
              <div className="chip info only-show-mobile">
                *1RM = 1 repetition maximum
              </div>
            )}
            <div className="rep-max">
              {showRMField(hideRMs, collectRepMax, "squat") && (
                <div className="input">
                  <label className="label" htmlFor="squat">
                    Squat 1RM
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxSquat"
                    value={repMaxSquat || ""}
                    handleChange={handleFieldChange}
                    placeholder="Enter here"
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "bench") && (
                <div className="input">
                  <label className="label" htmlFor="bench">
                    Bench 1RM
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    units={units}
                    imperial="lb"
                    className="text-input"
                    name="repMaxBench"
                    value={repMaxBench || ""}
                    handleChange={handleFieldChange}
                    placeholder="Enter here"
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "deadlift") && (
                <div className="input">
                  <label className="label" htmlFor="deadlift">
                    Deadlift 1RM
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxDeadlift"
                    value={repMaxDeadlift || ""}
                    handleChange={handleFieldChange}
                    placeholder="Enter here"
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "clean") && (
                <div className="input">
                  <label className="label" htmlFor="repMaxClean">
                    Clean 1RM
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxClean"
                    value={repMaxClean || ""}
                    handleChange={handleFieldChange}
                    placeholder="Enter here"
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "jerk") && (
                <div className="input">
                  <label className="label" htmlFor="repMaxJerk">
                    Jerk 1RM
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxJerk"
                    value={repMaxJerk || ""}
                    handleChange={handleFieldChange}
                    placeholder="Enter here"
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "snatch") && (
                <div className="input">
                  <label className="label" htmlFor="repMaxSnatch">
                    Snatch 1RM
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxSnatch"
                    value={repMaxSnatch || ""}
                    handleChange={handleFieldChange}
                    placeholder="Enter here"
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
              {showRMField(hideRMs, collectRepMax, "overheadPress") && (
                <div className="input">
                  <label className="label" htmlFor="repMaxOverheadPress">
                    Overhead Press 1RM
                  </label>
                  <UnitInput
                    required
                    min="1"
                    metric="kg"
                    imperial="lb"
                    units={units}
                    className="text-input"
                    name="repMaxOverheadPress"
                    value={repMaxOverheadPress || ""}
                    handleChange={handleFieldChange}
                    placeholder="Enter here"
                  />
                  <span className="unit">
                    {units === "imperial" ? "LB" : "KG"}
                  </span>
                </div>
              )}
            </div>

            {showRMText && (
              <div className="chip info mt-4 mobile-hidden">
                *1RM = 1 repetition maximum
              </div>
            )}

            <label className="checkbox-input mt-4 !flex !opacity-100">
              <input
                name="agreeTOS"
                type="checkbox"
                id="tos"
                onChange={handleFieldChange}
              />{" "}
              I agree to the MyStrengthBook
              <a
                href="https://mystrengthbook.com/terms-of-use/"
                target="_blank"
                rel="noopener noreferrer"
                data-button-type="text"
                role="button"
                className="!m-0 !p-0 !w-auto"
              >
                Terms of Use
              </a>
            </label>
          </section>

          <button
            data-button-type="primary"
            sz="large"
            onClick={handleUserDetails}
            className="mobile-hidden !w-1/2"
          >
            Continue
          </button>
          <button
            data-button-type="primary"
            sz="large"
            onClick={handleUserDetails}
            className="only-show-mobile"
          >
            Continue
          </button>
        </form>
      }
    />
  );
};

export default SignupDetailsView;
